<div
    class="card border border-primary cursor-pointer hover:scale-105 transition-transform w-full bg-base-100 shadow-xl rounded-none rounded-bl-3xl"
    (click)="cardClicked.emit()"
>
    <div class="card-body p-2 gap-3">
        <div class="flex flex-col gap-4 text-ellipsis overflow-hidden">
            <div class="flex flex-col">
                <h4 class="mb-0 text-lg truncate">{{ person.firstName }} {{ person.lastName }}</h4>
                <span class="truncate">{{ person.position }}</span>
            </div>
        </div>
        <div class="flex flex-col gap-2 text-xs">
            <div class="flex items-center gap-2">
                <iota-icon icon="phone" size="1" class="text-primary"></iota-icon>
                <div class="col-span-2 text-ellipsis overflow-hidden">{{ getPersonPhoneNumber(person) }}</div>
            </div>
            <div class="flex items-center gap-2">
                <iota-icon icon="at-symbol" size="1" class="text-primary"></iota-icon>
                <div class="col-span-2 text-ellipsis overflow-hidden">{{ getPersonEmail(person) }}</div>
            </div>
            <div class="flex items-center gap-2">
                <iota-icon icon="building-office" size="1" class="text-primary"></iota-icon>
                <div class="truncate col-span-2 text-ellipsis overflow-hidden">{{ parseAddress(person.addresses) }}</div>
            </div>
        </div>
        <div class="flex flex-row justify-end items-center">
            <button class="btn btn-error" (click)="deleteClicked.emit()" i18n>Delete</button>
        </div>
    </div>
</div>
